// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__RAyIN","center":"Footer_center__g3fOT","right":"Footer_right__j+ORQ","close":"Footer_close__+bw8D"};